import { createFileRoute } from "@tanstack/react-router"

import ReserveGuardCard from "../../../../../-components/ReserveGuardCard"

export const Route = createFileRoute(
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
)({
  staticData: {
    pageName: "Reservation Timeout",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { qrLookupID } = Route.useParams()
  const { sessionState } = Route.useRouteContext()

  return (
    <ReserveGuardCard
      iconName="clock"
      heading="reservationTimeout.heading"
      body="reservationTimeout.body"
      actionLabel="reservationTimeout.returnToRates"
      qrLookupID={qrLookupID}
      onAction={() =>
        navigate({
          to: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates",
          search: { endDate: sessionState.selectedEndDateOnly || undefined },
        })
      }
    />
  )
}
